// Locale date formatting shared across the dashboard (five components carried
// their own copy of this, one of which had drifted to short months — the
// short/long split is now explicit).

// Date-only strings (YYYY-MM-DD) parse as UTC midnight — pin to local so the
// displayed day doesn't shift in negative timezones. Full ISO timestamps pass
// through unchanged.
function parse(value: string): Date {
  return new Date(value.length === 10 ? `${value}T00:00:00` : value);
}

// The UTC calendar date of a photo/questionnaire timestamp. The server stores a
// participant-chosen photo date as UTC midnight, so the UTC date IS the chosen
// date — rendering the timestamp with local-time getters shifts it a day in
// negative timezones (1/1/2000 → 12/31/1999 7:00 PM). Always reduce to this
// before formatting a participant-facing date.
export function utcDateOnly(value: string): string {
  return value.slice(0, 10);
}

// Today as a LOCAL calendar date (YYYY-MM-DD). `toISOString().slice(0, 10)` is
// the UTC date, which sits one day ahead in negative timezones near midnight.
export function localToday(): string {
  const d = new Date();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${m}-${day}`;
}

// "August 10, 2026" — consent copy, account dates, photo folders.
export function longDate(value: string): string {
  const d = parse(value);
  return Number.isNaN(d.getTime())
    ? value
    : d.toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" });
}

// "Aug 10, 2026" — the Daily Log's denser rows.
export function shortDate(value: string): string {
  const d = parse(value);
  return Number.isNaN(d.getTime())
    ? value
    : d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
}
